import { useLocalization } from '@/hooks/use-localization';

type CloseProps = {
    setShowMenu: React.Dispatch<React.SetStateAction<boolean>>;
};

export const Close = ({ setShowMenu }: CloseProps) => {
    const { localize } = useLocalization();

    return (
        <div id="close-button-container" className="r-flex r-justify-end">
            <button onClick={() => setShowMenu(false)} aria-label={localize('close-menu')}>
                <img src="/assets/icons/close.svg" alt="" className="r-mt-2 r-h-8 r-w-8" />
            </button>
        </div>
    );
};
